// Normalizes URL tag IDs: returns an empty string for no value, preserves an
// uppercase leading K for emergency keyrings, and removes all other non-digits.
// Examples: "1122-3344" becomes "11223344"; "k0008-0648" becomes "K00080648".
export const normalizeTagId = (value) => {
    if (!value) return "";

    const upperCaseValue = value.toUpperCase();
    if (upperCaseValue.startsWith("K")) {
        return `K${upperCaseValue.slice(1).replace(/\D/g, "")}`;
    }

    return upperCaseValue.replace(/\D/g, "");
};

// Requests the device's current location and returns its latitude and longitude.
// If geolocation is unavailable, denied, or fails, both values are empty strings.
export const getCurrentCoordinates = async () => {
    if (!("geolocation" in navigator)) {
        return { latitude: "", longitude: "" };
    }

    try {
        const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        return {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
        };
    } catch (error) {
        return { latitude: "", longitude: "" };
    }
};
